export default "__VITE_ASSET__Dkx9tVo9__"